export const FEATURES = {
  PASSKEY_SUPPORT: "identity.passkey-support-2026-v1",
  USERNAME_CUSTOMIZATION: "identity.username-customization-2026-v1",
  EMAIL_OTP: "identity.email-otp-2026-v1",
};
